import { Typography } from '@mui/material';
import {
  CopyTestLinkButton,
  Flex,
  FlexColumn,
  GenerateAIButton,
  Loading,
  TestLineageNavButton,
} from '../../../components';
import { isInSaaSMode } from '../../../utils/common';
import { ModelRunsExpandedRowProps } from '../types';
import ModelRunsChart from './ModelRunsChart';

const ModelRunsExpandedRow = ({
  rowData,
  chartData,
  isFetching,
  onOpenAiChat,
  aiOptimizationEnabled,
}: ModelRunsExpandedRowProps) => (
  <FlexColumn sx={{ gap: 2 }}>
    <Flex sx={{ justifyContent: 'space-between' }}>
      <Typography sx={{ fontWeight: 500, color: 'common.gray2' }}>
        {isInSaaSMode()
          ? 'Task execution time and status over time'
          : 'Model execution time and status over time'}
      </Typography>
      <Flex sx={{ gap: 1, alignItems: 'center' }}>
        <TestLineageNavButton modelId={rowData.unique_id} />
        <CopyTestLinkButton testId={rowData.unique_id} />
        {aiOptimizationEnabled && (
          <GenerateAIButton onClick={() => onOpenAiChat(rowData)}>
            AI Optimization
          </GenerateAIButton>
        )}
      </Flex>
    </Flex>
    {isFetching ? <Loading size={24} /> : <ModelRunsChart data={chartData} />}
  </FlexColumn>
);

export default ModelRunsExpandedRow;
